import { useTikkieCookies } from '@/components/cookie-banner/use-tikkie-cookies.tsx';
import { BlokkieCookieBanner } from '@tikkie/blokkie';
import { useTranslation } from 'react-i18next';

export const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const { cookiePreferences, handleCookies, isCookiesSet } = useTikkieCookies();

  const showCookieBanner = !isCookiesSet();

  return (
    <BlokkieCookieBanner
      link={t('footer.cookies_url')}
      preferences={cookiePreferences}
      onAccept={handleCookies}
      onReject={handleCookies}
      open={showCookieBanner}
    />
  );
};
